export const getStatusText = (statusNumber) => {
    const statusMap = {
        0: "admin.match_status_0",
        1: "admin.match_status_1",
        2: "admin.match_status_2",
        3: "admin.match_status_3",
        4: "admin.match_status_4",
        5: "admin.match_status_5",
        6: "admin.match_status_6",
        7: "admin.match_status_7",
        8: "admin.match_status_8",
        9: "admin.match_status_9",
    };

    return statusMap[statusNumber] || "Unknown Status";
};
